import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { AxnRelyingParty } from "@idw-types/data/reference-data/axn";

type GetRelyingPartiesRequestResponse = {
    axnRelyingParties: Array<AxnRelyingParty>;
};

export const getRelyingPartiesRequest = async (): Promise<{ data: GetRelyingPartiesRequestResponse, error: any }> => {
    const route = apiRoutes.axnadminCore.axn.relyingparty;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};